import { useState } from 'react';

type ProfileAvatarProps = {
  name: string;
  src?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

const sizeClasses = {
  sm: 'h-10 w-10 text-xs',
  md: 'h-12 w-12 text-lg',
  lg: 'h-14 w-14 text-xl',
};

function InitialFallback({
  name,
  size,
  className = '',
}: {
  name: string;
  size: 'sm' | 'md' | 'lg';
  className?: string;
}) {
  const initial = (name?.trim()?.[0] || '?').toUpperCase();
  return (
    <div
      className={`flex shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-secondary to-[#1e2d4a] font-bold text-white shadow-md ${sizeClasses[size]} ${className}`}
      aria-hidden
    >
      {initial}
    </div>
  );
}

export default function ProfileAvatar({
  name,
  src,
  size = 'md',
  className = '',
}: ProfileAvatarProps) {
  const [failed, setFailed] = useState(false);
  const showImage = Boolean(src?.trim()) && !failed;

  if (!showImage) {
    return <InitialFallback name={name} size={size} className={className} />;
  }

  return (
    <img
      src={src!}
      alt=""
      referrerPolicy="no-referrer"
      onError={() => setFailed(true)}
      className={`shrink-0 rounded-xl object-cover shadow-md ring-2 ring-white/20 ${sizeClasses[size]} ${className}`}
    />
  );
}
